import Request from './request'

const Tariffication  = {
  //tariff
  getTariffPacketItem(id, callback) {
    Request.get('tariffication/tariff-packet-item/' + id).then(callback).catch(this.bad_answer)
  },
  getTariffBasePackets(callback) {
    Request.get('tariffication/tariff-base-packets').then(callback).catch(this.bad_answer)
  },
  getTariffPacketItems(params, callback) {
    Request.post('tariffication/tariff-packet-items', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  //tariffication
  getTarifficationPacketItems(params, callback) {
    Request.post('tariffication/tariffication-packet-items', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getTarifficationPacketItem(id, callback) {
    Request.get('tariffication/tariffication-packet-item/'+id).then(callback).catch(this.bad_answer)
  },
  //mno
  getMnoBasePackets(callback) {
    Request.get('tariffication/mno-base-packets').then(callback).catch(this.bad_answer)
  },
  getMnoPacketItems(params, callback) {
    Request.post('tariffication/mno-packet-items', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getMnoPacketItem(id, callback) {
    Request.get('tariffication/mno-packet-item/' + id).then(callback).catch(this.bad_answer)
  },
}

export default Tariffication
